/**
 * KiekkoKingi section controller: store-cta
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
        const sectionId = kkScript.dataset.sectionId;
        const rootId = kkScript.dataset.rootId;
        const initCta = () => {
          const root = document.getElementById(rootId);
          if (!root || root.dataset.ctaInitialized === 'true') return;
          const configNode = root.querySelector('[data-cta-config]');
          if (!configNode) return;
          let config;
          try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
          root.dataset.ctaInitialized = 'true';
          root.classList.add('is-enhanced');
          const video = root.querySelector('[data-cta-video]');
          const videoToggle = root.querySelector('[data-cta-video-toggle]');
          const videoLabel = root.querySelector('[data-cta-video-label]');
          const status = root.querySelector('[data-cta-status]');
          const today = root.querySelector('[data-cta-today]');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const mobileViewport = window.matchMedia('(max-width: 719px)');
          let wantsVideo = Boolean(config.autoplay);
          let timer;
          let observer;
          const syncVideo = () => {
            if (!videoToggle || !video) return;
            const paused = video.paused;
            videoToggle.dataset.paused = String(paused);
            videoToggle.setAttribute('aria-pressed', String(!paused));
            const label = paused ? config.playLabel : config.pauseLabel;
            videoToggle.setAttribute('aria-label', label);
            if (videoLabel) videoLabel.textContent = label;
          };
          const reconcileVideo = () => {
            if (!video) return;
            const canPlay = wantsVideo && !reducedMotion.matches && (!mobileViewport.matches || config.videoMobile) && !document.hidden;
            if (canPlay) {
              const promise = video.play();
              if (promise && typeof promise.catch === 'function') promise.catch(() => syncVideo());
            } else { video.pause(); }
            syncVideo();
          };
          const toggleVideo = () => { wantsVideo = video ? video.paused : false; reconcileVideo(); };
          const onVisibility = () => reconcileVideo();
          const parseTime = (value) => {
            const match = typeof value === 'string' && value.trim().match(/^([01]?\d|2[0-3]):([0-5]\d)$/);
            return match ? Number(match[1]) * 60 + Number(match[2]) : null;
          };
          const pad = (value) => String(value).padStart(2, '0');
          const compact = (minutes) => minutes % 60 === 0 ? String(Math.floor(minutes / 60)) : `${Math.floor(minutes / 60)}.${pad(minutes % 60)}`;
          const range = (open, close) => `${compact(open)}–${compact(close)}`;
          const fill = (template, values) => String(template || '').replace(/\{([a-z]+)\}/gi, (match, key) => Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match);
          const helsinkiNow = () => {
            const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: config.timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
            const parts = {};
            formatter.formatToParts(new Date()).forEach((part) => { if (part.type !== 'literal') parts[part.type] = Number(part.value); });
            const nativeDay = new Date(Date.UTC(parts.year, parts.month - 1, parts.day)).getUTCDay();
            return { weekday: nativeDay === 0 ? 7 : nativeDay, minutes: (parts.hour === 24 ? 0 : parts.hour) * 60 + parts.minute };
          };
          const updateStatus = () => {
            if (config.statusMode !== 'auto' || !status) return;
            let now;
            try { now = helsinkiNow(); } catch (error) { return; }
            const weekend = now.weekday >= 6;
            const open = parseTime(weekend ? config.weekendOpen : config.weekdayOpen);
            const close = parseTime(weekend ? config.weekendClose : config.weekdayClose);
            const valid = open !== null && close !== null && close > open;
            const isOpen = Boolean(valid && now.minutes >= open && now.minutes < close);
            root.dataset.statusState = isOpen ? 'open' : 'closed';
            status.textContent = isOpen ? config.openLabel : config.closedLabel;
            if (today) today.textContent = valid ? ` · ${fill(config.todayTemplate, { hours: range(open, close) })}` : ` · ${config.closedTodayLabel}`;
          };
          const scheduleStatus = () => {
            window.clearTimeout(timer);
            if (config.statusMode !== 'auto') return;
            timer = window.setTimeout(() => { updateStatus(); scheduleStatus(); }, Math.max(1000, 60000 - (Date.now() % 60000) + 50));
          };
          if (video) {
            video.addEventListener('play', syncVideo);
            video.addEventListener('pause', syncVideo);
            if (videoToggle) videoToggle.addEventListener('click', toggleVideo);
            reducedMotion.addEventListener('change', reconcileVideo);
            mobileViewport.addEventListener('change', reconcileVideo);
            document.addEventListener('visibilitychange', onVisibility);
            reconcileVideo();
          }
          updateStatus(); scheduleStatus();
          if (reducedMotion.matches || !('IntersectionObserver' in window)) root.classList.add('is-visible');
          else {
            observer = new IntersectionObserver((entries) => { if (entries.some((entry) => entry.isIntersecting)) { root.classList.add('is-visible'); observer.disconnect(); } }, { threshold: .16 });
            observer.observe(root);
          }
          root.ctaCleanup = () => {
            window.clearTimeout(timer);
            if (observer) observer.disconnect();
            if (video) {
              video.pause(); video.removeEventListener('play', syncVideo); video.removeEventListener('pause', syncVideo);
              reducedMotion.removeEventListener('change', reconcileVideo); mobileViewport.removeEventListener('change', reconcileVideo); document.removeEventListener('visibilitychange', onVisibility);
            }
            if (videoToggle) videoToggle.removeEventListener('click', toggleVideo);
            root.classList.remove('is-enhanced','is-visible');
            delete root.ctaCleanup; delete root.dataset.ctaInitialized;
          };
        };
        const matches = (event) => event.detail && String(event.detail.sectionId) === String(sectionId);
        const onLoad = (event) => { if (matches(event)) initCta(); };
        const onUnload = (event) => {
          if (!matches(event)) return;
          const root = document.getElementById(rootId); if (root && root.ctaCleanup) root.ctaCleanup();
          document.removeEventListener('shopify:section:load', onLoad); document.removeEventListener('shopify:section:unload', onUnload);
        };
        document.addEventListener('shopify:section:load', onLoad);
        document.addEventListener('shopify:section:unload', onUnload);
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCta, { once: true }); else initCta();
      })();
})();